import { render, staticRenderFns } from "./StaticContent.vue?vue&type=template&id=9f8d4ec0&"
import script from "./StaticContent.vue?vue&type=script&lang=ts&"
export * from "./StaticContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports